export default __webpack_public_path__ + "static/media/kitap6.ae890d50.jpg";